import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Tab, Tabs } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select/base";

export default function EmployeesList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [err, setErr] = useState({});
  const [data, setData] = useState({
    name: "",
    email: "",
    employee_id: "",
    blood_group: "",
    phone: "",
    designation: [],
  });

  const handleClose = () => {
    setShowModal(false);
    setData({
      name: "",
      email: "",
      employee_id: "",
      blood_group: "",
      phone: "",
      designation: [],
    });
  };

  const onChangeHandler = (key, value) => {
    setData({
      ...data,
      [key]: value,
    });
    setErr({
      ...err,
      [key]: "",
    });
  };

  const validate = () => {
    let temp = {};
    if (!data?.name?.trim()?.length) {
      temp = {
        ...temp,
        name: "Please enter name",
      };
    }
    if (!data?.email?.trim()?.length) {
      temp = {
        ...temp,
        email: "Please enter email",
      };
    }
    if (!data?.employee_id?.trim()?.length) {
      temp = {
        ...temp,
        employee_id: "Please enter employee id",
      };
    }
    if (!data?.blood_group?.trim()?.length) {
      temp = {
        ...temp,
        blood_group: "Please enter blood group",
      };
    }
    if (!data?.phone?.trim()?.length) {
      temp = {
        ...temp,
        phone: "Please enter phone number",
      };
    }
    if (!data?.designation?.length) {
      temp = {
        ...temp,
        designation: "Please select designation",
      };
    }
    if (Object.values(temp).length != 0) {
      setErr(temp);
      return false;
    } else {
      setErr({});
      return true;
    }
  };

  const submitHandler = () => {
    if (validate()) {
      let raw = {
        name: data?.name,
        email: data?.email,
        employee_id: data?.employee_id,
        blood_group: data?.blood_group,
        phone: data?.phone,
        designation: data?.designation?.map((ele) => ele?._id),
        profile : ""
      };
      //   if (data?.id) {
      //     raw = {
      //       ...raw,
      //       id: data?.id,
      //     };
      //     dispatch(
      //       addProjects(raw, (res) => {
      //         if (res) {
      //           handleClose();
      //         }
      //       })
      //     );
      //   } else {
      //     dispatch(
      //       addProjects(raw, (res) => {
      //         if (res) {
      //           handleClose();
      //         }
      //       })
      //     );
      //   }
    }
  };

  return (
    <div className="admin__dashboard">
      <div className="container">
        <div className="row">
          <div className="main__section">
            <div className="d-flex justify-content-between mb-5">
              <div className="back__btn" onClick={() => navigate('/dashboard')}>
                <img src="/back-arrow.svg" alt="" />
                Back
              </div>
              <Button onClick={() => setShowModal(true)} className="addBtn">
                Add Employees
              </Button>
            </div>
            <Tabs
              defaultActiveKey="projects"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="projects" title="Projects">
                <div className="projects">
                  <div className="table-wrapper">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Sl.No</th>
                          <th scope="col">Employee Id</th>
                          <th scope="col">Profile Picture</th>
                          <th scope="col">Name</th>
                          <th scope="col">Designation</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>01</td>
                          <td>Lorem Ipsum is </td>
                          <td>
                            <img
                              src="https://picsum.photos/seed/picsum/200/300"
                              alt=""
                            />
                          </td>
                          <td>Lorem Ipsum is </td>
                          <td>Lorem Ipsum</td>
                          <td className="actions">
                            <button className="btn-action"><img src="/edit.svg" alt="" /></button>
                            <button className="btn-action"><img src="/delete.svg" alt="" /></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>

        <Modal className="main__modal" show={showModal} onHide={handleClose} size="lg" centered>
          <h2>Add Employee</h2>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter name"
                    onChange={(e) => onChangeHandler("name", e.target?.value)}
                    value={data?.name}
                  />
                  <span className="text-danger">{err?.name}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter email"
                    onChange={(e) => onChangeHandler("email", e.target?.value)}
                    value={data?.email}
                  />
                  <span className="text-danger">{err.email}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Employee ID</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter employee ID"
                    onChange={(e) =>
                      onChangeHandler("employee_id", e.target?.value)
                    }
                    value={data?.employee_id}
                  />
                  <span className="text-danger">{err.employee_id}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Blood Group</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter blood group"
                    onChange={(e) =>
                      onChangeHandler("blood_group", e.target?.value)
                    }
                    value={data?.blood_group}
                  />
                  <span className="text-danger">{err.blood_group}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Contact Number</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter phone number"
                    onChange={(e) => onChangeHandler("phone", e.target?.value)}
                    value={data?.phone}
                  />
                  <span className="text-danger">{err.phone}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Designation</Form.Label>
                  <Select
                    placeholder="Select Designation"
                    name="designation"
                    options={[]}
                    value={data?.designation}
                    getOptionLabel={(o) => o?.dial_code}
                    getOptionValue={(o) => o?._id}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(e) => {
                      onChangeHandler("designation", e);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                  <span className="text-danger">{err.designation}</span>
                </Form.Group>
              </div>
              <div className="col-md-12">
                <div className="modal__footer">
                  <Button variant="primary" onClick={submitHandler}>
                    Submit
                  </Button>
                  <Button variant="primary" onClick={()=>setShowModal(false)}>
                    Cancel
                  </Button>
                </div>

              </div>
            </div>
          </Modal.Body>

        </Modal>

    </div>
  );
}
